import InteractionService from "@configuratorware/configurator-frontendgui/App/Services/InteractionService";
import { Services } from "@configuratorware/configurator-frontendgui/App/ServiceLocator";
import { PMS_REGEX } from "../../../lib/constants";
export default class CustomInteractionService extends InteractionService {
  constructor() {
    super();
  }

  init() {
    super.init();
  }

  async _addToCart() {
    Services.ui.show("globalLoader");
    const { customdata, item } = Services.configurator.state.configuration;
    const { selectedAmounts, userSelectedCalculation } = customdata;
    let max = item.attributes.find(
      (att) => att.identifier.toUpperCase() === "MAXIMUMAMOUNTTOORDER"
    );
    if (max) {
      max = max?.values[0].value;
      const maxAmount = max > 0 ? max : 9999999;
      const amount = selectedAmounts[Object.keys(selectedAmounts)[0]];
      if (amount > maxAmount) {
        Services.ui.hide("globalLoader");
        return;
      }
    }
    if (!userSelectedCalculation) {
      this.addToCart();
      Services.ui.hide("globalLoader");
      return;
    }
    if (userSelectedCalculation.length < 1) {
      this.addToCart();
      Services.ui.hide("globalLoader");
      return;
    }
    let specialColors = Object.keys(userSelectedCalculation).filter(
      (key) => userSelectedCalculation[key]
    );
    // TODO: Prüfen ob Wet auf false gesetzt
    let hasPMS = false;
    item.attributes.some((attr) => {
      if (attr.identifier === "hasPMS") hasPMS = attr.values[0].value;
      return attr.identifier === "hasPMS";
    });
    if (hasPMS) {
      specialColors = specialColors.filter((calc) => calc.match(PMS_REGEX));
      specialColors = specialColors.map((calc) => calc.split(PMS_REGEX)[1]);
      if (specialColors.length === 0) this.addToCart();
      if (specialColors.length === 1) {
        let isAccepted = true;
        const minAmount = specialColors[0];
        Object.keys(selectedAmounts).some((key) => {
          const amount = selectedAmounts[key];
          if (amount < minAmount) isAccepted = false;
          return !isAccepted;
        });
        if (isAccepted) this.addToCart();
      } else {
        /* let isAccepted = false;
        let idx = 0;
        Object.keys(selectedAmounts).some((key) => {
          for(let i = 0; i < specialColors.length -2; i++){
            const minAmount = specialColors[i];
            let amount = selectedAmounts[key];
            if (amount < minAmount) break;
            else if(amount < specialColors[i+1] ){
              isAccepted = true;
              break;
            }
            idx = i;
            isAccepted = true;
          }
          let amount = selectedAmounts[key];
          if (amount < minAmount) isAccepted = false;
          return !isAccepted;
        }); */
        console.log("Has invalid number of pms options selected");
      }
    } else {
      this.addToCart();
    }
    // Services.ui.hide('globalLoader');
  }
}
